import { createReducer } from 'typesafe-actions';
import { NormalizedEntity } from 'Interfaces/Common';

import {
  clearDocumentInteract,
  resetPagesRendered,
  setPageRendered,
  setPagesForFile,
  setPdfFiles,
} from './actionCreators';

export interface DocumentInteractEntry {
  pdfDocumentFiles: string[];
  pagesPerDocument: Record<string, number[]>;
  loadedPagesCount: number;
  renderedPages: Record<number, boolean>;
}

const initialStatePerEntry: DocumentInteractEntry = {
  pdfDocumentFiles: [],
  pagesPerDocument: {},
  loadedPagesCount: 0,
  renderedPages: {},
};

export default createReducer({} as NormalizedEntity<DocumentInteractEntry>)
  .handleAction(setPdfFiles, (state, action) => {
    const { documentId, files } = action.payload;
    const prev = state[documentId] || initialStatePerEntry;
    return {
      ...state,
      [documentId]: {
        ...prev,
        pdfDocumentFiles: files,
      },
    };
  })
  .handleAction(setPagesForFile, (state, action) => {
    const { documentId, pdfFile, pagesNumber } = action.payload;
    const prev = state[documentId] || initialStatePerEntry;
    return {
      ...state,
      [documentId]: {
        ...prev,
        pagesPerDocument: {
          ...prev.pagesPerDocument,
          [pdfFile]: Array.from({ length: pagesNumber }, (_, index) => index + 1),
        },
      },
    };
  })
  .handleAction(resetPagesRendered, (state, action) => {
    const documentId = action.payload;
    const prev = state[documentId] || initialStatePerEntry;
    return {
      ...state,
      [documentId]: {
        ...prev,
        loadedPagesCount: 0,
        renderedPages: {},
      },
    };
  })
  .handleAction(setPageRendered, (state, action) => {
    const { documentId, pageNumber } = action.payload;
    const prev = state[documentId] || initialStatePerEntry;
    return {
      ...state,
      [documentId]: {
        ...prev,
        loadedPagesCount: prev.loadedPagesCount + 1,
        renderedPages: {
          ...state[documentId].renderedPages,
          [pageNumber]: true,
        },
      },
    };
  })
  .handleAction(clearDocumentInteract, (state, action) => {
    const newState = { ...state };
    delete newState[action.payload];
    return newState;
  });
